import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
import {ItemsGroup} from "../../views/setting/itemsGroups/itemsGroups";
import {Item, User} from "../../model";
import {UserService} from "../../services/user.service";
import {ConfirmationService, Message} from "primeng/api";
import {Router} from "@angular/router";
import {UserProfileComponent} from "../user-profile/user-profile.component";
import {appConfig} from "../../app.config";

@Component({
    selector: 'app-user-settings',
    templateUrl: './user-picture.component.html',
    styleUrls: ['./user-picture.component.scss'],
    providers: []
})
export class UserPictureComponent implements OnInit {
    id: string;
    public user: User;
    userData: any;
    picture: string;

    public logs: Log[];
    oldPass: any;
    msgs: Message[] = [];
    @Input() rowId;
    @Input() refShow;
    item: Item;
    public fullurl = '';
    public imgSrc: any;


    modalRef: NgbModalRef;
    form: FormGroup;
    public imgUrl = appConfig.publicUrl;


    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private router: Router,
                private userService: UserService,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;

            // this.oldPass = userdata.password;
           this.changePicUrl();

        }
    }

    ngOnInit() {
        this.imgSrc = "Choose an image";

        this.form = this.formBuilder.group({

            picture: new FormControl('')

        });
        if (this.id) {
            this.changePicUrl();

            // this.activeModal.dismiss('');
            // localStorage.removeItem('filter');

            this.userService.getById(this.id).subscribe(
                user => {
                    this.id = user.id;
                    this.user = user;
                    this.form.patchValue({

                        picture: user.picture,

                    });
                }, error => {
                    console.log(error);
                }
            );


        }
    }

    onSubmit() {
        if (this.form.valid) {
            let user: User = new User();
            user.id=this.id;
            user.picture = this.form.controls['picture'].value;
            const currentUser = JSON.parse(localStorage.getItem('currentUser'));
            // JSON.parse(localStorage.getItem('picture'));
            this.userService.updatePic(user).subscribe(
                ruser => {
                    // this.id = ruser.id;
                    this.msgs = [];
                    this.fullurl = this.imgUrl+'upload/'+user.picture;
                    // localStorage.setItem('currentUser', JSON.stringify({picture: user.picture}));

                    currentUser.picture = ruser.picture;
                    localStorage.setItem('currentUser',JSON.stringify(currentUser));
                    this.changePicUrl();

                    this.msgs.push({
                        severity: 'success',
                        summary: '',
                        detail: this.translate.instant('Your picture is updated successfully')

                    });
                    this.form.reset();
                    localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                }, error => {
                    console.log(error);
                }
            );
        }else {
            this.msgs = [];
            this.msgs.push({
                severity: 'error',
                summary: '',
                detail: this.translate.instant('You\'re didn\'t select a picture yet' )
            });
            this.validateAllFormFields(this.form)
        }
    }
    changePicUrl(){
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser ) {
     /*       this.picture = currentUser.picture;
            this.fullurl = this.imgUrl+'upload/'+this.picture*/;
            this.fullurl = this.imgUrl+'upload/'+currentUser.picture;
        }
    }
    deletePic(item: string) {
        item = this.id;
        this.userService.getById(this.id).subscribe(
            user => {
                this.id = user.id;
                this.user = user;

            });
        // window.alert(this.user.picture);
        if(this.user.picture !=='Avatar.jpg') {
            this.confirmationService.confirm({
                header: this.translate.instant('Confirm Delete'),
                message: this.translate.instant('Are you sure  you wanna delete this picture ?'),
                icon: 'fa fa-trash',
                accept: () => {
                    if (item) {

                        this.userService.deletePic(item).subscribe();

                        this.msgs.push({
                            severity: 'success',
                            summary: '',
                            detail: this.translate.instant('The picture has been deleted successfully')
                        });
                    }
                    window.scrollTo(0, 0);

                    setTimeout(() => {

                        this.router.navigate(['/users/show', this.id]);
                    },1000);

                }
            });
        }
    }
    onFileChange(event) {
        this.changePicUrl();
        let reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            let file = event.target.files[0];
            this.imgSrc = file.name;

            reader.readAsDataURL(file);
            reader.onload = () => {
                this.form.get('picture').setValue({
                    filename: file.name,
                    filetype: file.type,
                    value: reader.result.split(',')[1]
                })
            };
        }
    }


    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    close() {
        this.changePicUrl();
        this.activeModal.dismiss('done');
    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                this.changePicUrl();
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/user-picture/user-picture.component.ts